"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "w-full 2xl:container mx-auto p-4 flex flex-col"
};
const _hoisted_2 = { class: "text-black text-[30px] py-[30px] uppercase font-bold" };
const _hoisted_3 = { class: "flex flex-col sm:flex-row border-[#929292] border-t-2 mb-3" };
const _hoisted_4 = { class: "w-full sm:w-1/3 pt-[30px] flex flex-col sm:pr-[30px]" };
const _hoisted_5 = { class: "grow" };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "font-bold text-[20px] mb-3 uppercase" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = { class: "hidden sm:block w-full sm:w-2/3" };
const vue_3 = require("vue");
const CartSummary_vue_1 = __importDefault(require("./CartSummary.vue"));
const vue_router_1 = require("vue-router");
const TextareaInput_vue_1 = __importDefault(require("../../components/Form/TextareaInput.vue"));
const CreateOrderRequest_1 = __importDefault(require("../../stores/checkout/CreateOrderRequest"));
const ShippingMode_vue_1 = __importDefault(require("./ShippingMode.vue"));
const ShippingAddress_vue_1 = __importDefault(require("./ShippingAddress.vue"));
const ShippingAddressExport_vue_1 = __importDefault(require("./ShippingAddressExport.vue"));
const PaymentMode_vue_1 = __importDefault(require("./PaymentMode.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const checkoutStore_1 = require("../../stores/checkout/checkoutStore");
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Checkout',
    setup(__props) {
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const checkoutStore = (0, checkoutStore_1.useCheckoutStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const orderRequest = (0, vue_3.ref)(undefined);
        const orderRequestValid = (0, vue_3.computed)(() => {
            var _a;
            if (orderRequest.value === undefined) {
                return false;
            }
            return (_a = orderRequest.value) === null || _a === void 0 ? void 0 : _a.isValid();
        });
        (0, vue_3.watch)(activeCart, () => {
            var _a, _b;
            if (activeCart.value !== undefined) {
                orderRequest.value = new CreateOrderRequest_1.default((_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.id);
                // Checkout-ra navigáláskor üres kosár esetén a dashboard-ra dobjuk a user-t.
                if (((_b = activeCart.value) === null || _b === void 0 ? void 0 : _b.products.length) == 0) {
                    router.push({ name: "home" });
                }
            }
        }, { immediate: true });
        const sendOrder = async () => {
            var _a;
            try {
                if (!orderRequest.value)
                    return;
                const response = await checkoutStore.sendOrder(router, orderRequest.value);
                await cartsStore.loadCarts(router);
                await router.push({
                    name: "shop_success_order",
                    query: { axaptaId: (_a = response.axaptaIdList) !== null && _a !== void 0 ? _a : null },
                    params: { id: response.id }
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return ((0, vue_2.unref)(activeCart) !== undefined && orderRequest.value !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("checkout_header", "Checkout", "checkout")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createVNode)(ShippingMode_vue_1.default, {
                                    id: "checkout-shipping-mode",
                                    "order-request": orderRequest.value
                                }, null, 8, ["order-request"]),
                                (!((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ShippingAddress_vue_1.default, {
                                        key: 0,
                                        id: "checkout-shipping-address",
                                        "order-request": orderRequest.value
                                    }, null, 8, ["order-request"]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ShippingAddressExport_vue_1.default, {
                                        key: 1,
                                        id: "checkout-shipping-address-export",
                                        "order-request": orderRequest.value
                                    }, null, 8, ["order-request"]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(PaymentMode_vue_1.default, {
                                    id: "checkout-payment-mode",
                                    "order-request": orderRequest.value
                                }, null, 8, ["order-request"]),
                                (orderRequest.value !== undefined)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("note", "Note", "checkout")), 1),
                                        (0, vue_2.createVNode)(TextareaInput_vue_1.default, {
                                            id: "checkout-textarea-input",
                                            modelValue: orderRequest.value.note,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((orderRequest.value.note) = $event)),
                                            "max-length": 200,
                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('notice_placeholder', 'Comment here', 'checkout'),
                                            class: "my-5",
                                            rows: 2
                                        }, null, 8, ["modelValue", "placeholder"])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(CartSummary_vue_1.default, { class: "sm:hidden" })
                            ]),
                            (0, vue_2.createElementVNode)("button", {
                                id: "checkout-send-order-button",
                                disabled: !(0, vue_2.unref)(orderRequestValid),
                                class: "btn btn-rounded btn-primary text-sm sm:text-base w-full h-[63px] font-bold text-[20px] mt-3",
                                onClick: _cache[1] || (_cache[1] = ($event) => (sendOrder()))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("send_order", "Send order", "checkout")), 9, _hoisted_8),
                            (((_c = (0, vue_2.unref)(currentUser)) === null || _c === void 0 ? void 0 : _c.hasPermission((0, vue_2.unref)(PermissionEnum_1.QuotationPermissionEnum).QUOTATION_READ)) &&
                                !((_d = (0, vue_2.unref)(currentUser)) === null || _d === void 0 ? void 0 : _d.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)) &&
                                ((_e = (0, vue_2.unref)(activeCart).products) === null || _e === void 0 ? void 0 : _e.length) !== 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                    key: 0,
                                    id: "checkout-create-printable-quote-link",
                                    to: { name: 'shop_quote' },
                                    target: "_blank",
                                    class: "btn btn-rounded btn-warning text-sm sm:text-base w-full h-[63px] font-bold text-[20px] mt-3"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("create_printable_quote", "Create Printable Quote", "checkout")), 1)
                                    ]),
                                    _: 1
                                }))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createVNode)(CartSummary_vue_1.default)
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
